import { useIntlModule } from 'utils/intl/useIntlModule';
import messages from './warningBanner.intl.json';

export const useWarningBannerIntl = () => useIntlModule(messages);
